import React from 'react'
import PropTypes from 'prop-types'

import { useTranslation } from 'shared/hooks/useSafeTranslation'
import useStyle from 'shared/hooks/useStyle'
import QrCodeRetry from '../QrCodeRetry'
import styles from './QRScanSummary.style'

const propTypes = {
    loggerNumber: PropTypes.string,
    qrCode: PropTypes.string,
    isAnswered: PropTypes.bool,
}

const QRScanSummary = ({
    isAnswered = false,
    qrCode,
    loggerNumber,
}) => {
    const { t } = useTranslation()
    const classes = useStyle(styles)

    return (
        <>
            { !isAnswered && (
                <div css={classes.root}>
                    {t('NO_SCAN_PERFORMED') }
                </div>
            )}

            { isAnswered && (
                <QrCodeRetry
                    qrCode={qrCode}
                    loggerNumber={loggerNumber}
                />
            ) }

        </>
    )
}

QRScanSummary.propTypes = propTypes

export default QRScanSummary
